import 'vite/modulepreload-polyfill';

import './styles/main.css';

import {createApp} from 'vue';

import LrLogin from './LrLogin.vue';

createApp(LrLogin).mount('#app');
